export { default as hallway } from './hallway.png'
export { default as layingBed1 } from './laying-bed1.png'
export { default as layingBed2 } from './laying-bed2.png'
export { default as lobby1 } from './lobby1.png'
export { default as lobby2 } from './lobby2.png'
export { default as standingBed } from './standing-bed.png'
